import type { ReactNode } from "react";
import {
  Banner,
  BannerContent,
  Text,
  type ValidationStatus,
} from "@/design-system/salt";
type AlertCalloutVariant = "success" | "warning" | "error" | "info";

interface AlertCalloutProps {
  variant: AlertCalloutVariant;
  title?: string;
  children: ReactNode;
  className?: string;
}

const statusByVariant: Record<AlertCalloutVariant, ValidationStatus> = {
  success: "success",
  warning: "warning",
  error: "error",
  info: "info",
};

/** Salt Banner composition for application callouts and recovery states. */
export function AlertCallout({
  variant,
  title,
  children,
  className,
}: AlertCalloutProps) {
  const status = statusByVariant[variant];

  return (
    <Banner
      className={className}
      role={status === "error" || status === "warning" ? "alert" : "status"}
      status={status}
      style={{ alignItems: "flex-start" }}
      variant="secondary"
    >
      <BannerContent style={{ minWidth: 0 }}>
        {title && (
          <Text as="h4" style={{ marginBottom: "var(--salt-spacing-50)" }} styleAs="h4">
            {title}
          </Text>
        )}
        <Text as="div" color="primary">
          {children}
        </Text>
      </BannerContent>
    </Banner>
  );
}
